import { Modal, SimpleCallback, Button, SimpleText } from 'platform-components';
import React from 'react';

import { CertificateModalColumn } from '../__column/certificate-modal__column';
import { CertificateModalConditions } from '../__conditions/certificate-modal__conditions';
import { CertificateModalDescription } from '../__description/certificate-modal__description';
import { CertificateModalEmail } from '../__email/certificate-modal__email';
import { CertificateModalFormFieldWrap } from '../__form-field-wrap/certificate-modal__form-field-wrap';
import { CertificateModalFormTitle } from '../__form-title/certificate-modal__form-title';
import { CertificateModalForm } from '../__form/certificate-modal__form';
import { CertificateModalFullName } from '../__full-name/certificate-modal__full-name';
import { CertificateModalHeader } from '../__header/certificate-modal__header';
import { CertificateModalImage } from '../__image/certificate-modal__image';
import { CertificateModalLocality } from '../__locality/certificate-modal__locality';
import { CertificateModalSchool } from '../__school/certificate-modal__school';
import { EmailData, FullNameData, LocalityData, SchoolData, TextData, ImageData } from '../typings';

import './certificate-modal__query-form.scss';

interface Props {
    handleAcceptClick: SimpleCallback;
    handleCancel: SimpleCallback;

    canChangeData: boolean;
    isButtonDisabled: boolean;
    canCancelSuggestion: boolean;

    imageData: ImageData;
    textData: TextData;

    fullNameData: FullNameData;
    localityData: LocalityData;
    schoolData: SchoolData;
    emailData: EmailData;
}

export const CertificateModalQueryForm = (props: Props) => {
    const {
        handleAcceptClick,
        handleCancel,

        imageData,
        textData,
        localityData,
        emailData,
        fullNameData,
        schoolData,

        canChangeData,
        isButtonDisabled,
        canCancelSuggestion,
    } = props;

    const { titleId, descriptionId, formTitleId, acceptButtonId, cancelButtonId } = textData;

    return (
        <>
            {titleId && (
                <Modal.Header>
                    <CertificateModalHeader titleId={titleId} />
                </Modal.Header>
            )}
            <Modal.Content mix="certificate-modal__content">
                <CertificateModalColumn type="conditions">
                    <CertificateModalImage imageData={imageData} />
                    <CertificateModalConditions />
                </CertificateModalColumn>
                <CertificateModalColumn type="form">
                    {descriptionId && <CertificateModalDescription descriptionId={descriptionId} />}
                    {formTitleId && <CertificateModalFormTitle formTitleId={formTitleId} />}
                    <CertificateModalForm>
                        <CertificateModalFormFieldWrap key="full-name-wrap">
                            <CertificateModalFullName canChangeData={canChangeData} fullNameData={fullNameData} />
                        </CertificateModalFormFieldWrap>
                        <CertificateModalFormFieldWrap key="locality-wrap">
                            <CertificateModalLocality canChangeData={canChangeData} localityData={localityData} />
                        </CertificateModalFormFieldWrap>
                        <CertificateModalFormFieldWrap key="school-wrap">
                            <CertificateModalSchool canChangeData={canChangeData} schoolData={schoolData} />
                        </CertificateModalFormFieldWrap>
                        <CertificateModalFormFieldWrap key="email-wrap">
                            <CertificateModalEmail canChangeData={canChangeData} emailData={emailData} />
                        </CertificateModalFormFieldWrap>
                    </CertificateModalForm>
                </CertificateModalColumn>
            </Modal.Content>
            <Modal.Footer mix="certificate-modal__footer">
                {canCancelSuggestion && (
                    <Button
                        className="certificate-modal__remind-button"
                        onClick={handleCancel}
                        view={Button.VIEW.SECONDARY}
                    >
                        <SimpleText id={cancelButtonId} />
                    </Button>
                )}
                <Button
                    className="certificate-modal__confirm-button"
                    disabled={isButtonDisabled}
                    onClick={handleAcceptClick}
                >
                    <SimpleText id={acceptButtonId} />
                </Button>
            </Modal.Footer>
        </>
    );
};
